module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "billingInformationSection"
    }
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v("\n    " + _vm._s(_vm.$t("billing.labels.billingInformation")) + "\n  ")]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 card-stat"
  }, [_c('loading-indicator')], 1)]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('div', {
    staticClass: "bg-blue-grey-100 p-30"
  }, [(_vm.hasBillingInformation) ? _c('div', {
    staticClass: "counter counter-md text-xs-left"
  }, [_c('span', {
    staticClass: "counter-number grey-600"
  }, [_vm._v(_vm._s(_vm.billingInformation.first_name) + " " + _vm._s(_vm.billingInformation.last_name))]), _vm._v(" "), _c('div', {
    staticClass: "counter-label m-b-5 m-t-10"
  }, [(_vm.team.is_reseller) ? _c('p', [_c('span', {
    staticClass: "p-r-10"
  }, [_vm._v(_vm._s(_vm.billingInformation.company_name))]), _vm._v(" " + _vm._s(_vm.$t("billing.information.labels.taxID")) + " : " + _vm._s(_vm.billingInformation.tax_id))]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "address1"
  }, [_vm._v(_vm._s(_vm.billingInformation.address1))]), _vm._v(" "), _c('span', {
    staticClass: "address2"
  }, [_vm._v(_vm._s(_vm.billingInformation.address2))]), _vm._v(" "), _c('span', {
    staticClass: "city"
  }, [_vm._v(_vm._s(_vm.billingInformation.city))]), _vm._v(" "), _c('span', {
    staticClass: "state"
  }, [_vm._v(_vm._s(_vm.billingInformation.state))]), _vm._v(" "), _c('span', {
    staticClass: "postal-code"
  }, [_vm._v(_vm._s(_vm.billingInformation.zipcode))]), _vm._v(" "), _c('span', {
    staticClass: "country"
  }, [_vm._v(_vm._s(_vm.billingInformation.country))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("billing.information.labels.billingContactPhone")) + " : " + _vm._s(_vm.billingInformation.contact_phone))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("billing.information.labels.billingEmail")) + " : " + _vm._s(_vm.billingInformation.contact_email))])]), _vm._v(" "), _c('div', {
    staticClass: "counter-label text-uppercase m-b-5 m-t-20"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onChangeInformationButtonClick
    }
  }, [_vm._v(_vm._s(_vm.$t("billing.information.action.changeInformation")) + "\n            ")])])]) : _c('div', [_c('p', {
    staticClass: "font-size-16"
  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.noBillingInformation")))]), _vm._v(" "), _c('div', {
    staticClass: "counter-label text-uppercase m-b-5 m-t-20"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onChangeInformationButtonClick
    }
  }, [_vm._v(_vm._s(_vm.$t("billing.information.action.addBillingInformation")) + "\n            ")])])])]), _vm._v(" "), _c('modal', {
    ref: "billingInformationFormModal",
    staticClass: "modal-primary"
  }, [_c('h4', {
    staticClass: "modal-title",
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("billing.information.labels.enterBillingInformation")))]), _vm._v(" "), _c('billing-information-form', {
    ref: "billingInformationForm",
    attrs: {
      "team": _vm.team,
      "billingInformation": _vm.billingInformation
    },
    on: {
      "save": _vm.onBillingInformationFormSaved,
      "cancel": _vm.onBillingInformationFormCancel
    },
    slot: "body"
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bd9bda2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/billings/payments/BillingInformation.vue
// module id = 509
// module chunks = 1